module.exports = __webpack_public_path__ + "img/gamblers.a2d9eef5.png";